<template>
    <v-row justify="center">
        <v-dialog v-model="dialogProp" persistent scrollable max-width="500">
            <ValidationObserver ref="obs">
                <v-card>
                    <v-progress-linear
                        v-if="loading"
                        indeterminate
                        color="primary"
                        rounded
                        height="6"
                    ></v-progress-linear>

                    <v-card-title class="pa-0 shadow-1">
                        <v-img
                            :src="
                                require('@/assets/illustrations/bg_modal_card.svg')
                            "
                            cover
                            position="left bottom"
                            class="align-center"
                            height="65px"
                        >
                            <v-card-title
                                class="font-weight-medium primary--text"
                            >
                                {{ titleMode }} Categoria
                            </v-card-title>
                        </v-img>
                    </v-card-title>

                    <vuescroll
                        :ops="{
                            bar: { background: '#bacfcec0', keepShow: true }
                        }"
                    >
                        <v-card-text style="max-height: 350px">
                            <v-form>
                                <v-row dense>
                                    <v-col cols="12">
                                        <ValidationProvider
                                            name="Titulo"
                                            rules="required"
                                            v-slot="{ errors }"
                                        >
                                            <v-text-field
                                                required
                                                filled
                                                rounded
                                                class="rounded-small"
                                                dense
                                                label="Titulo"
                                                name="title"
                                                prepend-inner-icon="mdi-label-variant"
                                                type="text"
                                                color="blue-grey"
                                                v-model="categoryData.title"
                                                :error-messages="errors"
                                            ></v-text-field>
                                        </ValidationProvider>
                                    </v-col>

                                    <v-col cols="12">
                                        <!-- <ValidationProvider
                                            name="Descripcion"
                                            rules="required"
                                            v-slot="{ errors }"
                                        > -->
                                            <v-text-field
                                                filled
                                                rounded
                                                class="rounded-small"
                                                dense
                                                label="Descripcion (Opcional)"
                                                name="description"
                                                prepend-inner-icon="mdi-image-text"
                                                color="blue-grey"
                                                v-model="
                                                    categoryData.description
                                                "
                                                :error-messages="errors"
                                            ></v-text-field>
                                        <!-- </ValidationProvider> -->
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-card-text>
                    </vuescroll>

                    <v-divider></v-divider>

                    <v-card-actions class="mx-2">
                        <v-spacer></v-spacer>
                        <v-hover v-slot:default="{ hover }">
                            <v-btn
                                text
                                rounded
                                class="mr-1"
                                :color="hover ? 'error' : 'grey'"
                                @click="closeDialog"
                                >Cancelar</v-btn
                            >
                        </v-hover>

                        <v-hover v-slot:default="{ hover }">
                            <v-btn
                                rounded
                                :loading="loading"
                                :disabled="loading"
                                color="success"
                                :class="hover ? 'shadow-2' : 'shadow-4'"
                                class="px-8"
                                @click.stop="submitForm()"
                                >{{ submitButtonMode }}</v-btn
                            >
                        </v-hover>
                    </v-card-actions>
                </v-card>
            </ValidationObserver>
        </v-dialog>
    </v-row>
</template>

<script>
import vuescroll from "vuescroll";

const initialData = {
    categoryData: {
        title: "",
        description: ""
    }
};
export default {
    props: {
        dialogProp: {
            type: Boolean,
            default: false
        },
        mode: {
            type: String,
            default: "register"
        },
        dataToForm: {
            type: Object
        }
    },
    components: { vuescroll },
    data() {
        return {
            dialog: this.dialogProp,
            loading: false,
            categoryData: { ...initialData.categoryData },
            errorData: "",
            activeAlert: false,
            colorAlert: ""
        };
    },
    beforeUpdate() {
        if (this.mode !== "register")
            this.categoryData = {...this.dataToForm};
    },
    computed: {
        titleMode() {
            return this.mode === "register" ? "Nueva" : "Editar";
        },
        submitButtonMode() {
            return this.mode === "register" ? "añadir" : "actualizar";
        }
    },

    methods: {
        closeDialog() {
            this.categoryData = { ...initialData.categoryData };
            this.$emit("dialog:close");
        },
        async submitForm() {
            if (this.mode === "register") {
                const response = await this.$store.dispatch(
                    "categories/REGISTER_CATEGORY",
                    this.categoryData
                );
                if (response === 422){
                this.$snotify.error("El nombre ya fue establecido ", "Error");
                return
                }else
                this.$snotify.success("Categoria creada con éxito.", "¡Hecho!");
            } else {
                const response = await this.$store.dispatch(
                    "categories/EDIT_CATEGORY",
                    this.categoryData
                );
                this.$snotify.success(
                    "Categoria actualizada con éxito.",
                    "¡Hecho!"
                );
            }
            this.closeDialog();
        }
        /*
        async sendform() {
            try {
                this.loading = true;
                const enviar = {
                    ClientName: this.ClientName,
                    ClientUser: this.ClientUser,
                    ClientPassword: this.ClientPassword,
                    ClientEmail: this.ClientEmail,
                    ClientIP: this.ClientIP,
                    ClientNameBd: this.ClientNameBd,
                    ClientPort: this.ClientPort,
                    ip_sokect: this.ip_sokect,
                    user_sokect: this.user_sokect,
                    clave_sokect: this.clave_sokect,
                    port_sokect: this.port_sokect
                };
                const response = await this.$store.dispatch(
                    "clients/REGISTER_CLIENTS",
                    enviar
                );
                this.$snotify.success("Cliente creado con éxito.", "¡Hecho!");
                this.loading = false;
                this.dialogVisible = false;
                this.resetform();
            } catch (error) {
                this.$snotify.error(error.response.data, "¡Error!");
                // this.errorData = error.response.data;
                // this.activeAlert = true;
                // this.colorAlert = "red";
                this.loading = false;
            }
        },
        eventdialog() {
            this.activeAlert = false;
        }*/
    }
};
</script>
